import { useContext, memo, useEffect } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";
import axios from "axios";
import InputTel from "./InputTel";

const Address = memo(() => {
	const { inputs, setInputs, errors, setErrors } = useContext(Data);

	useEffect(() => {
		setErrors({
			...errors,
			postcode: inputs.postcode === null ? "*必須" : null,
			address: inputs.address === null ? "*必須" : null,
			tel: inputs.tel === null ? "*必須" : null,
		});
		return () => {
			setErrors({
				...errors,
				sample: null,
				postcode: null,
				address: null,
				tel: null,
			});
		};
	}, []);

	const postcodeChange = (e) => {
		setInputs({ ...inputs, postcode: e.target.value });
		e.target.value.length > 0
			? setErrors(() => ({ ...errors, postcode: null }))
			: setErrors(() => ({ ...errors, postcode: "*必須" }));
	};
	const addressChange = (e) => {
		setInputs({ ...inputs, address: e.target.value });
		e.target.value.length > 0
			? setErrors(() => ({ ...errors, address: null }))
			: setErrors(() => ({ ...errors, address: "*必須" }));
	};

	const fillAddress = async (e) => {
		const res = await axios.get(
			"https://api.zipaddress.net/?zipcode=" + e.target.value
		);
		if (res.data.code === 200) {
			setInputs({
				...inputs,
				address: res.data.data.pref + res.data.data.city + res.data.data.town,
			});
			setErrors({ ...errors, address: null });
		}
	};

	return (
		<div className={styles.addressBox}>
			<label className={styles.labelCommon}>
				<p className="bold">
					郵便番号<span>{errors.postcode}</span>
				</p>
				<input
					type="text"
					name="postcode"
					maxLength={8}
					onChange={postcodeChange}
					onBlur={fillAddress}
					value={inputs.postcode}
					placeholder="4660058"
				/>
			</label>
			<label className={styles.labelCommon}>
				<p className="bold">
					住所<span>{errors.address}</span>
				</p>
				<input
					type="text"
					name="address"
					value={inputs.address}
					onChange={addressChange}
					placeholder="愛知県名古屋市昭和区白金1-4-3"
				/>
			</label>
			<InputTel label={"お電話番号"} require />
		</div>
	);
});

export default Address;
